enum InvoiceBillingReason {
    DRAFT = 'draft',
    OPEN = 'open',
    VOID = 'void',
    PAID = 'paid',
    UNCOLLECTIBLE = 'uncollectible',
}

export default InvoiceBillingReason;
